export function hasElementScrollbar(element: HTMLElement): boolean {
  return element.scrollHeight > element.clientHeight;
}
